import Vue from "vue";
import Vuex from "vuex";
import Department from "./Department";
import AdminUsers from "./AdminUsers";
import Auth from "./Auth";
import Employee from "./Employee";
import Room from "./Room";
import Tasks from "./Tasks";
import Template from "./Template";
import Role from "./Role";
import Lookup from "./Lookup";
import Dashboard from "./Dashboard";
import settings from "./settings";
import ActiveTemplate from "./ActiveTemplate";
import Maintenance from "./Maintenance";
import Reports from "./Reports";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    Department,
    AdminUsers,
    Auth,
    Employee,
    Room,
    settings,
    Tasks,
    Template,
    Role,
    Lookup,
    Dashboard,
    ActiveTemplate,
    Maintenance,
    Reports,
  },
});
